import * as React from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useBloomreach, useBrPageContext } from '../../../context/context.js';
import { getCategoryRoute } from './utils/get-category-route.js';
import { createCategoryBreadcrumb } from './utils/create-category-breadcrumb.js';
import { createSubCategoryBreadcrumb } from './utils/create-subcategory-breadcrumb.js';
import { createProductBreadcrumb } from './utils/create-product-breadcrumb.js';

const CmsProductBreadcrumbs = ({ product , sku  })=>{
    var ref;
    const { locale  } = useIntl();
    const { pageModel  } = useBloomreach();
    const page = useBrPageContext();
    const productType = (ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name;
    const categoryRoute = getCategoryRoute(pageModel, productType);
    if (!categoryRoute) {
        console.warn('Could not find a product category route to render PDP breadcrumbs');
        return null;
    }
    const categoryBreadcrumb = createCategoryBreadcrumb(pageModel, categoryRoute, page);
    const subCategoryBreadcrumb = createSubCategoryBreadcrumb(categoryRoute, product, productType, locale, page);
    const productBreadcrumb = createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale);
    const breadcrumbs = [
        categoryBreadcrumb,
        subCategoryBreadcrumb,
        productBreadcrumb
    ].filter(Boolean);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};
var CmsProductBreadcrumbs$1 = CmsProductBreadcrumbs;

export { CmsProductBreadcrumbs, CmsProductBreadcrumbs$1 as default };
//# sourceMappingURL=ProductBreadcrumbs.js.map
